// withGameExpiry.jsx
import { createElement } from 'react';
import { Navigate } from 'react-router-dom';
import GameFortuneClose from "./components/game-fortune-card/GameFortuneClose";

const GAME_END_DATE = new Date('2027-02-28T23:59:59');

export const isGameExpired = () => new Date() > GAME_END_DATE;

const withGameExpiry = (Component) => {
  return function GameExpiryWrapper(props) {
    if (isGameExpired()) {
      return createElement(GameFortuneClose);
    }
    return createElement(Component, props);
  };
};

export default withGameExpiry;